import { render, staticRenderFns } from "./discountsHistory.vue?vue&type=template&id=0ccdb3fa&"
import script from "./discountsHistory.vue?vue&type=script&lang=js&"
export * from "./discountsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports